import { ActionTree } from 'vuex'
import { RootState } from '@/store/types'
import { PronosticoHidricoInterface, PronosticoHidricoService } from '@/domain/services/PronosticoHidricoService'
import { PronosticoHidricoState, StoreError } from '@/store/modules/pronostico-hidrico/types'

const PronosticoHidrico: PronosticoHidricoInterface = new PronosticoHidricoService()

export const actions: ActionTree<PronosticoHidricoState, RootState> = {
  async getPronosticoHidrico ({ commit }) {
    try {
      const actionResponse = await PronosticoHidrico.getPronosticoHidrico()
      return commit(actionResponse.type, actionResponse.payload)
    } catch (error) {
      const storeError: StoreError = { state: true, message: error, name: 'STORE_ERROR' }
      return commit('STORE_ERROR', storeError)
    }
  },
  deletePronosticoHidrico ({ commit }) {
    return commit('PRONOSTICO_HIDRICO_DELETED', undefined)
  }
}
